module.exports = __webpack_public_path__ + "static/media/motivation2.a01a730d.png";